import BrokenBuildingIcon from "../../../../../Theme/CustomIcons/Icons/Building/BrokenBuildingIcon";
import LetterRequestIcon from "../../../../../Theme/CustomIcons/Icons/ContentEdit/LetterRequestIcon";
import ReportingAnalysysIcon from "../../../../../Theme/CustomIcons/Icons/ContentEdit/ReportingAnalysysIcon";
import LeaveManagementIcon from "../../../../../Theme/CustomIcons/Icons/CustomIcons/LeaveManagementIcon";
import CalendarIcon from "../../../../../Theme/CustomIcons/Icons/Time/CalendarIcon";
import UserCircleAddIcon from "../../../../../Theme/CustomIcons/Icons/Users/UserCircleAddIcon";

// being used in setupEntityCard.js
export const setupEntityOptions = [
  {
    id: 1,
    title: "Overview",
    description: "Setup legal entity region, currency and timezone",
    duration: "2 mins",
    component: "OverviewDrawerParent",
  },
  {
    id: 2,
    title: "Dimensions",
    description: "Create and setup levels for the dimension",
    duration: "3 mins",
    component: "DimensioneDrawerListingParent",
  },
  {
    id: 3,
    title: "Modules",
    description: "Setup modules for this legal entity",
    duration: "4 mins",
    component: "ModulesDrawer",
  },
  {
    id: 4,
    title: "Theme Settings",
    description: "Setup Theme for the Legal Entity",
    duration: "2 mins",
    component: "ThemeSelectionDrawer",
  },
];

// being used in formatS2.js
export const numberFormatOptions = {
  label: "Number Format",
  description: "Select the number format for the entity",
  options: [
    { value: "1,234,567.89", label: "1,234,567.89" },
    { value: "1.234.567,89", label: "1.234.567,89" },
  ],
};

// being used in formatS2.js
export const temperatureOptions = {
  label: "Temperature",
  description: "Select the temperature format for the entity",
  options: [
    { value: "Celsius", label: "Celsius" },
    { value: "Fahrenheit", label: "Fahrenheit" },
  ],
  // being used in formatS2.js
};

// being used in formatS2.js
export const timeFormatOptions = {
  label: "Time formats",
  description: "Select the time format for the entity",
  options: [
    { value: "12-hour", label: "12 hour" },
    { value: "24-hour", label: "24 hour" },
  ],
};

// being used in formatS2.js
export const firstDayOptions = {
  label: "First Day of the Week",
  description: "Select the first day of the week for the entity",
  options: [
    { value: "Monday", label: "Monday" },
    { value: "Sunday", label: "Sunday" },
  ],
};

// being used in formatS2.js
export const dateFormatOptions = {
  label: "Date formats",
  description: "Select the date format for the entity",
  options: [
    { value: "DD/MM/YYYY", label: "DD/MM/YYYY" },
    { value: "MM/DD/YYYY", label: "MM/DD/YYYY" },
    { value: "YYYY/MM/DD", label: "YYYY/MM/DD" },
  ],
};

// being used in formatS2.js
export const measurementOptions = {
  label: "Measurement System",
  description: "Select the measurement system for the entity",
  options: [
    { value: "Metric", label: "Metric" },
    { value: "US/UK", label: "US/UK" },
  ],
};

// being used in formatS2.js
export const roundingOptionsObject = {
  "Round off to nearest digit": "Round off to nearest digit",
  "Round up": "Round up",
  "Round down": "Round down",
  "No rounding": "No rounding",
};

// being used in formatS2.js
export const calendarOptions = {
  label: "Calendar",
  description: "Select the calendar type for the entity",
  options: [
    { value: "Gregorian", label: "Gregorian" },
    { value: "Hijri", label: "Hijri" },
    { value: "Other", label: "Other" },
  ],
};

// being used in tradeLicenseDrawer.js
export const issuingAuthorityOptions = [
  "DED (Department of Economic Development)",
  "Free Zone Authority",
  "DMCC (Dubai Multi Commodities Centre)",
  "DIFC (Dubai International Financial Centre)",
  "RAKEZ (Ras Al Khaimah Economic Zone)",
  "Sharjah Media City (Shams)",
  "Fujairah Creative City",
  "ADGM (Abu Dhabi Global Market)",
];

// being used in tradeLicenseDrawer.js
export const licenseTypeOptions = [
  "1 Year",
  "2 Years",
  "3 Years",
  "5 Years",
  "Lifetime",
];

// being used in tradeLicenseDrawer.js
export const legalTypeOptions = [
  "Sole Proprietorship",
  "Limited Liability Company (LLC)",
  "Civil Company",
  "Partnership",
  "Branch of Foreign Company",
  "Branch of Local Company",
  "Freelancer",
  "Government Entity",
];

// being used in tradeLicenseDrawer.js
export const licenseStatusOptions = [
  "Active",
  "Expired",
  "Inactive",
  "Suspended",
  "Pending Renewal",
  "Cancelled",
];

export const modules = [
  {
    key: "company_announcement",
    icon: <BrokenBuildingIcon size="large" />,
    title: "Company Announcement",
    description:
      "Announcements. PSX Notices Company Announcements CDC Notice SECP Notices NCCPL",
  },
  {
    key: "roster_management",
    icon: <CalendarIcon size="large" />,
    title: "Roster Management",
    description:
      "Announcements. PSX Notices Company Announcements CDC Notice SECP Notices NCCPL",
  },
  {
    key: "leave_management",
    icon: <LeaveManagementIcon size="large" />,
    title: "Leave Management",
    description:
      "Announcements. PSX Notices Company Announcements CDC Notice SECP Notices NCCPL",
  },
  {
    key: "reporting_analysis",
    icon: <ReportingAnalysysIcon size="large" />,
    title: "Reporting and Analysis",
    description:
      "Announcements. PSX Notices Company Announcements CDC Notice SECP Notices NCCPL",
  },
  {
    key: "employee_onboarding",
    icon: <UserCircleAddIcon size="large" />,
    title: "Employee Onboarding",
    description:
      "Announcements. PSX Notices Company Announcements CDC Notice SECP Notices NCCPL",
  },
  {
    key: "letter_request",
    icon: <LetterRequestIcon size="large" />,
    title: "Letter Request",
    description:
      "Announcements. PSX Notices Company Announcements CDC Notice SECP Notices NCCPL",
  },
];
// ====================ACTUAL DUMMY==================
export const employees = [
  {
    id: 1,
    firstName: "John",
    lastName: "Doe",
    designation: "Software Engineer",
    department: "IT",
  },
  {
    id: 2,
    firstName: "Alice",
    lastName: "Smith",
    designation: "HR Manager",
    department: "Human Resources",
  },
  {
    id: 3,
    firstName: "Michael",
    lastName: "Johnson",
    designation: "Accountant",
    department: "Finance",
  },
  {
    id: 4,
    firstName: "Tina",
    lastName: "Lee",
    designation: "Marketing Executive",
    department: "Marketing",
  },
];

// companies
export const companies = [
  {
    name: "MERP Technologies LLC",
    status: "enabled",
    dimensions: 5,
    users: 54,
    country: "United Arab Emirates",
    createdAt: "23 April 2025",
  },
  {
    name: "Nova Systems Pvt Ltd",
    status: "disabled",
    dimensions: 8,
    users: 120,
    country: "India",
    createdAt: "10 March 2025",
  },
  {
    name: "Orion Logistics FZCO",
    status: "enabled",
    dimensions: 3,
    users: 37,
    country: "United Arab Emirates",
    createdAt: "05 February 2025",
  },
];
// Dummy activity logs for Entity detail view
export const dummyEntityAuditLogs = [
  {
    _id: "log1",
    action: "create",
    timestamp: new Date().toISOString(),
    comment: "Entity created with base settings",
    user: {
      id: "u1",
      name: { firstName: "Alex", lastName: "Morgan" },
      email: "alex@example.com",
    },
  },
  {
    _id: "log2",
    action: "update",
    timestamp: new Date(Date.now() - 3600 * 1000 * 26).toISOString(),
    comment: "Localization updated to AED",
    user: {
      id: "u2",
      name: { firstName: "Priya", lastName: "Sharma" },
      email: "priya@example.com",
    },
  },
];

// Dummy comments for Entity detail view
export const dummyEntityComments = [
  {
    _id: "c1",
    text: "Please review entity dimensions before enabling.",
    createdAt: new Date().toISOString(),
    user: {
      name: { firstName: "Sam", lastName: "Lee" },
      email: "sam@example.com",
    },
  },
  {
    _id: "c2",
    text: "Looks good to proceed.",
    createdAt: new Date(Date.now() - 1000 * 60 * 45).toISOString(),
    user: {
      name: { firstName: "Jordan", lastName: "Kim" },
      email: "jordan@example.com",
    },
  },
];

export const DimensionsData = [
  {
    id: 1,
    title: "Branch Locations",
    enabled: true,
    departmentsCount: 8,
    employeesCount: 69,
    createdOn: "13 October 2025",
    country: "Pakistan",
  },
  {
    id: 2,
    title: "Departments",
    enabled: false,
    departmentsCount: 2,
    employeesCount: 27,
    createdOn: "23 April 2025",
    country: "United Arab Emirates",
  },
  {
    id: 3,
    title: "Trade License",
    enabled: true,
    departmentsCount: 8,
    employeesCount: 84,
    createdOn: "26 March 2025",
    country: "India",
  },
];
